<template>
  <div>
    <div class="opacity-display-anim">
      <div>
        <div class="row">
          <form>
            <div class="col m4 s12 input-field">
              <label class="active" for="#search">Buscar</label>
              <input
                type="text"
                style="font-size: 1rem !important"
                placeholder="Escribe algo..."
                id="search"
                v-model="filterKey"
              />
            </div>
            <div class="col s6 m2 input-field">
              <label class="active" for="">Mostrar</label>
              <select
                v-model="pageLength"
                class="browser-default"
                name=""
                id=""
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="0" selected>TODOS</option>
              </select>
            </div>
            <div class="col s6 m2 input-field">
              <label class="active" for="">Separador</label>
              <select v-model="separador" class="browser-default" name="" id="">
                <option
                  v-for="(_separador, nombre) in separadores"
                  :key="_separador"
                  :selected="_separador === separador"
                  :value="_separador"
                >
                  {{ nombre }}
                </option>
              </select>
            </div>

            <div class="input-field col">
              <button @click="downloadCSV" type="button" class="btn green">
                EXPORTAR CSV
              </button>
            </div>
          </form>
        </div>
      </div>
      <div class="row">
        <div class="col s6">
          <span class="left flow-text">{{ rows.length }}</span>
        </div>
        <div class="col s6">
          <div class="right" style="display: inline-flex">
            <div class="waves-effect">
              <span @click="changePage(page - 1)"
                ><i class="material-icons">chevron_left</i></span
              >
            </div>
            <div>
              <span class="flow-text">{{ page }}/{{ totalPages }}</span>
            </div>
            <div class="waves-effect">
              <span @click="changePage(page + 1)"
                ><i class="material-icons">chevron_right</i></span
              >
            </div>
          </div>
        </div>
      </div>
      <div _if="rows.length" class="row datatable">
        <table
          :class="{ 'responsive-table': responsive }"
          style="white-space: nowrap"
        >
          <thead>
            <tr>
              <th>Acciones</th>
              <th
                v-for="(alias, key) in columns"
                :key="key"
                @click="sortBy(key)"
                :class="{ active: sortKey == key }"
              >
                <span>{{ alias }}</span>
                <i v-if="sortOrders[key] > 0" class="mdi mdi-chevron-up"> </i>
                <span v-else class="mdi mdi-chevron-down"> </span>
              </th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(row, index) in filteredData"
              :key="index"
              class="opacity-display-anim"
            >
              <td>
                <button
                  v-show="row_clicked"
                  class="btn btn-floating btn-small blue"
                  @click="row_clicked(index)"
                >
                  <i class="material-icons">more_horiz</i>
                </button>
                <button
                  v-show="delete_rows"
                  @click="deleteRow(data, index)"
                  class="btn btn-floating btn-small red"
                >
                  <i class="material-icons">delete</i>
                </button>
              </td>
              <td v-for="(alias, key) in columns" :key="key">
                <span v-if="parsers && parsers[key]">{{
                  parsers[key](row, key)
                }}</span>
                <span v-else>{{ row[key] }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    delete_rows: Boolean,
    parsers: Object,
    data: Object,
    indexes: Array,
    rows: Array,
    columns: Object,
    responsive: Boolean,
    row_clicked: Function,
    sort_key: String,
    export_separator: String,
  },

  data: function () {
    var sortOrders = {};
    Object.keys(this.columns).forEach((key) => {
      sortOrders[key] = 1;
    });

    return {
      filterKey: undefined,
      separadores: {
        "Coma ,": ",",
        Tabulador: "\t",
        "Barra |": "|",
        "Diagonal /": "/",
      },
      separador: this.export_separator ?? "\t",
      sortKey: this.sort_key || "",
      pageLength: 0,
      page: 1,
      sortOrders: sortOrders,
    };
  },
  filters: {
    capitalize: function (str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
  },
  methods: {
    deleteRow(source, index) {
      if (this.delete_rows) {
        console.log("delete");
        delete source[index];
      }
    },
    downloadCSV() {
      let blob = this.csvReportBlob(this.data),
        filename = "reporte.csv";

      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", filename);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },
    csvReportBlob(data) {
      let separador = this.separador,
        csv = [Object.keys(this.columns).join(separador)];
      Object.values(data).forEach((row) => {
        let csv_row = [];
        Object.keys(this.columns).forEach((column) => {
          if (this.parsers && this.parsers[column])
            csv_row.push(this.parsers[column](row, column));
          else csv_row.push(row[column]);
        });
        csv.push(csv_row.join(separador));
      });
      let csvstring = csv.join("\n");
      let blob = new Blob([csvstring], { type: "text/csv;charset=utf-8;" });
      return blob;
    },
    changePage: function (page) {
      let p = page,
        totalPages = this.totalPages;

      this.page = p < 1 ? 1 : p > totalPages ? totalPages : p;
      this.$forceUpdate();
    },
    sortBy: function (key) {
      this.sortKey = key;
      this.sortOrders[key] *= -1;
      this.$forceUpdate();
    },
  },
  computed: {
    filteredData: function () {
      let sortKey = this.sortKey,
        page = this.page,
        pageLength = this.pageLength,
        filterKey = this.filterKey && this.filterKey.toLowerCase(),
        order = this.sortOrders[sortKey] || 1,
        indexes = this.indexes,
        //rows = this.rows,
        filtered = indexes,
        data = this.data,
        result = {};

      if (filterKey) {
        filtered = indexes.filter((index) => {
          let row = data[index];
          return Object.keys(row).some((column) => {
            return (
              JSON.stringify(row[column]).toLowerCase().indexOf(filterKey) > -1
            );
          });
        });
      }

      if (sortKey) {
        filtered = filtered.sort((a, b) => {
          a = data[a][sortKey];
          b = data[b][sortKey];
          return (a === b ? 0 : a > b ? 1 : -1) * order;
        });
      }
      if (filtered.length) {
        if (this.pageLength * 1)
          filtered = filtered.slice((page - 1) * pageLength, page * pageLength);
        filtered.forEach((index) => {
          result[index] = data[index];
        });
        return result;
      } else return {};
    },
    totalPages() {
      let n = this.rows.length,
        l = this.pageLength;
      return n > 0 ? parseInt(n / l) + (n % l > 0 ? 1 : 0) : 0;
    },
  },
};
</script>